import AppContent from '../feature-module/components/AppContent';
import TopHeader from '../feature-module/components/header/TopHeader';
import Footer from '../feature-module/components/Footer/Footer';
import { useLocation } from 'react-router-dom';
import { ProwlChatWidget } from '../feature-module/components/common/ui/ProwlChatWidget';
import { Helmet } from 'react-helmet-async';
import DeletionBanner from '../feature-module/components/common/ui/DeletionBanner';
import { useAuth } from '../context/AuthContext';
import { FEATURE_FLAGS, useFeatureFlag } from '../config/featureFlags';
import { PROWL_RESULTS_ROUTE } from '../lib/prowl/contracts';

// import ProviderPortalOnboardingGate from '../feature-module/components/onboarding/ProviderPortalOnboardingGate';

const DefaultLayout = () => {
  const { customerAccountStatus } = useAuth();
  const location = useLocation();
  const isHomePage = location.pathname.replace(/\/$/, '') === '/home';
  // design-spec 1i/1j: on the landing hero the "Ask Prowl" input does the
  // widget's job, and on the results page the fused command bar does — a
  // second floating entry point for the same conversation competes with
  // both. Gated behind the flag so, with it off, this page behaves exactly
  // as before this feature existed.
  const prowlV2Enabled = useFeatureFlag(FEATURE_FLAGS.prowlV2Customer);
  const isResultsPage = location.pathname.startsWith(PROWL_RESULTS_ROUTE);
  const hideFloatingWidget = prowlV2Enabled && (isHomePage || isResultsPage);
  return (
    <div>
      <Helmet defaultTitle="HirePanther" titleTemplate="%s | HirePanther">
        <meta
          name="description"
          content="Book local services and connect with trusted providers. Browse, compare, and book securely on HirePanther."
        />
        <meta property="og:site_name" content="HirePanther" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="en_CA" />
        <meta
          property="og:image"
          content="https://cdn.hirepanther.ca/social/hirepanther-og-default.png"
        />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:image"
          content="https://cdn.hirepanther.ca/social/hirepanther-og-default.png"
        />
      </Helmet>
      <div>
        {/* <AppSidebar /> */}
        <div className="">
          {isHomePage ? (
            <div className="fixed w-full bg-white max-w-[1980px] z-20 top-0">
              {customerAccountStatus === 'pending_deletion' && (
                <div>
                  <DeletionBanner
                    permanentlyDeletedAt={'2026-04-10T16:27:28.190Z'}
                  />
                </div>
              )}
              <TopHeader />
            </div>
          ) : (
            <>
              {customerAccountStatus === 'pending_deletion' && (
                <div>
                  <DeletionBanner
                    permanentlyDeletedAt={'2026-04-10T16:27:28.190Z'}
                  />
                </div>
              )}
              <TopHeader />
            </>
          )}

          <div className="px-4 md:px-6 laptop:px-14 ">
            <AppContent />
          </div>
          <Footer />
          {!hideFloatingWidget && <ProwlChatWidget />}
          {/* <ProviderPortalOnboardingGate /> */}
        </div>
      </div>
    </div>
  );
};

export default DefaultLayout;
